import { createRoot } from "react-dom/client";
import '@/lib/i18n'; // Initialize i18n
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);